






import {Component, Prop, Watch} from 'vue-property-decorator'
import Vue from 'vue'

@Component({
    name: "painting-by-numbers-close-button"
})
export default class PaintingByNumbersCloseButton extends Vue {
    onClose() {
        this.$emit('close')
    }
}
